export default "__VITE_ASSET__B5c64J08__"